import Vue from 'vue'

// 图片URL设置过滤器
export function setBackground(url, type) {
  if (!url || url == "") {
    return "";
  } else if (type == 'img') {
    if (url.indexOf("http://") != -1 || url.indexOf("https://") != -1) {
      return url;
    } else {
      return window.imageUrlBase + url;
    }
  } else if (url.indexOf("http://") != -1 || url.indexOf("https://") != -1) {
    return {
      "background-image": "url(" + url + ")"
    }
  } else if (url.indexOf("data:image") != -1) {
    return {
      "background-image": "url(" + url + ")"
    }
  } else {
    return {
      "background-image": "url(" + window.imageUrlBase + url + ")"
    }
  }
}
// 时间过滤器
export function timeStampConversionText(time, splitStr, defaultSr) {
  if (time == undefined || time == '') {
    return defaultSr || "";
  }
  time *= 1;

  let date = new Date(time);
  let M = date.getMonth() + 1;
  let y = date.getFullYear();
  let d = date.getDate();
  let h = date.getHours(); //时
  let m = date.getMinutes(); //分
  let s = date.getSeconds();

  if (M < 10) M = "0" + M;
  if (d < 10) d = "0" + d;
  if (h < 10) h = "0" + h;
  if (m < 10) m = "0" + m;
  if (s < 10) s = "0" + s;
  if (splitStr == "yyyy.MM.dd") {
    return y + "." + M + "." + d;
  } else if (splitStr == "yyyy") {
    return y;
  } else if (splitStr == "HH:mm") {
    return h + ":" + m;
  } else if (splitStr == "MM.dd") {
    return M + "." + d;
  } else if (splitStr == "MM/dd") {
    return M + "/" + d;
  } else if (splitStr == "dd") {
    return d;
  } else if (splitStr == "MM.dd HH:mm") {
    return M + "." + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy.MM.dd HH:mm") {
    return y + "." + M + "." + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy-MM-dd HH:mm") {
    return y + "-" + M + "-" + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy-MM-dd") {
    return y + "-" + M + "-" + d;
  } else if (splitStr == "yyyy.MM.dd HH:mm:ss") {
    return y + "." + M + "." + d + " " + h + ":" + m + ":" + s;
  }
}

// 时间过滤器
export function dateConversionText(date, splitStr, defaultSr) {
  if (!date) {
    return defaultSr || "";
  }
  let M = date.getMonth() + 1;
  let y = date.getFullYear();
  let d = date.getDate();
  let h = date.getHours(); //时
  let m = date.getMinutes(); //分
  let s = date.getSeconds();

  if (M < 10) M = "0" + M;
  if (d < 10) d = "0" + d;
  if (h < 10) h = "0" + h;
  if (m < 10) m = "0" + m;
  if (s < 10) s = "0" + s;
  if (splitStr == "yyyy.MM.dd") {
    return y + "." + M + "." + d;
  } else if (splitStr == "yyyy") {
    return y;
  } else if (splitStr == "HH:mm") {
    return h + ":" + m;
  } else if (splitStr == "MM.dd") {
    return M + "." + d;
  } else if (splitStr == "MM/dd") {
    return M + "/" + d;
  } else if (splitStr == "dd") {
    return d;
  } else if (splitStr == "MM.dd HH:mm") {
    return M + "." + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy.MM.dd HH:mm") {
    return y + "." + M + "." + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy-MM-dd HH:mm") {
    return y + "-" + M + "-" + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy-MM-dd") {
    return y + "-" + M + "-" + d;
  } else if (splitStr == "yyyy.MM.dd HH:mm:ss") {
    return y + "." + M + "." + d + " " + h + ":" + m + ":" + s;
  }
}

// 时间过滤器
export function timeTextConversionText(dateText, splitStr, defaultSr) {
  if (!dateText) {
    return defaultSr || "";
  }
  const date = new Date(dateText.replace(/-/g, "/"));
  let M = date.getMonth() + 1;
  let y = date.getFullYear();
  let d = date.getDate();
  let h = date.getHours(); //时
  let m = date.getMinutes(); //分
  let s = date.getSeconds();

  if (M < 10) M = "0" + M;
  if (d < 10) d = "0" + d;
  if (h < 10) h = "0" + h;
  if (m < 10) m = "0" + m;
  if (s < 10) s = "0" + s;
  if (splitStr == "yyyy.MM.dd") {
    return y + "." + M + "." + d;
  } else if (splitStr == "yyyy") {
    return y;
  } else if (splitStr == "HH:mm") {
    return h + ":" + m;
  } else if (splitStr == "MM.dd") {
    return M + "." + d;
  } else if (splitStr == "MM/dd") {
    return M + "/" + d;
  } else if (splitStr == "dd") {
    return d;
  } else if (splitStr == "MM.dd HH:mm") {
    return M + "." + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy.MM.dd HH:mm") {
    return y + "." + M + "." + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy-MM-dd HH:mm") {
    return y + "-" + M + "-" + d + " " + h + ":" + m;
  } else if (splitStr == "yyyy-MM-dd") {
    return y + "-" + M + "-" + d;
  } else if (splitStr == "yyyy.MM.dd HH:mm:ss") {
    return y + "." + M + "." + d + " " + h + ":" + m + ":" + s;
  } else if(splitStr == "MM.dd HH:mm") {
    return M + "." + d + " " + h + ":" + m;
  }
}

/**
 * 毫秒转时间格式
 * @param {Object} time
 */
export function millisecondConversionText(time) {
  time = Math.floor(time / 1000);
  if (time >= 3600) {
    let h = Math.floor(time / 3600);
    time = time % 3600;
    let m = Math.floor(time / 60);
    let s = time % 60;
    if (h < 10) h = "0" + h;
    if (m < 10) m = "0" + m;
    if (s < 10) s = "0" + s;
    return h + ":" + m + ":" + s;
  } else {
    let m = Math.floor(time / 60);
    let s = time % 60;
    if (m < 10) m = "0" + m;
    if (s < 10) s = "0" + s;
    return m + ":" + s;
  }
  return time;
}



// WEBPACK FOOTER //
// ./src/filters/index.js